import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePodcastStatusCheckQuery = createQueryHook(
  MembershipsSpotifyIntegrationsApiClient.getPodcast,
  {
    queryKey: ['podcastStatusCheck'],
  },
)
